import { render, staticRenderFns } from "./closing-sent.vue?vue&type=template&id=3e2b8fb2"
import script from "./closing-sent.vue?vue&type=script&lang=js"
export * from "./closing-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports